import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HttpErrorResponse,
	HttpClient,
	HttpBackend
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { LocalStorageService } from '@services/local-storage/local-storage.service';
import { GET_UNREAD_NOTIFICATIONS_COUNT_ADMIN } from 'environments/api.path'
import { NotificationService } from '@services/notification.service';
import {environment} from 'environments/environment.dev'


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	private httpWithoutInterceptor: HttpClient;
	private timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	constructor(
		private readonly _router: Router,
		private readonly _storageService: LocalStorageService,
		private readonly _snackbar: SnackbarService,
		private readonly _dialog: MatDialog,
		private readonly httpBackend: HttpBackend,
		private readonly notification: NotificationService
	) {
		this.httpWithoutInterceptor = new HttpClient(httpBackend);
	 }

	intercept(
		request: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<unknown>> {
		const token = this._storageService.getTokenAuth();
		const environment = this._storageService.getEnviorment();
		const isLoginRequest = request.url.includes('/auth/login');
		if (!isLoginRequest && token) {
			this.fetchNotificationCount(token)
		}
		const modifiedReq = request.clone({
			setHeaders: this.getHeaders(token, environment),
		});

		return next.handle(modifiedReq).pipe(
			catchError((err: HttpErrorResponse) => {
				this.handleHttpError(err);
				return throwError(() => err);
			})
		);
	}
		private fetchNotificationCount(token: string) {
    this.httpWithoutInterceptor.get(
      `${environment.api_path}${GET_UNREAD_NOTIFICATIONS_COUNT_ADMIN}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    )
    .subscribe({
      next: (res: any) => {
        this.notification.updateCount(res.data);
      },
      error: () => {}
    });
  }

	private getHeaders(token: string | null, environment: string | null): { [key: string]: string } {
		const headers: { [key: string]: string } = {
			'Accept': '*/*',
			// 'Content-Type': 'application/json',
			'ngrok-skip-browser-warning': '69420'
		};

		if (token) {
			headers['Authorization'] = `Bearer ${token}`;
			headers['environment'] = environment || '';
			headers['Access-Control-Allow-Origin'] = '*';
			headers['Access-Control-Allow-Credentials'] = 'true';
		}

		return headers;
	}

	private handleHttpError(err: HttpErrorResponse): void {
		if (!navigator.onLine || err.status === 0) {
			let msg = "No internet connection"
			this._snackbar.notify(msg, 2);
			return
		}
		switch (err.status) {
			case 401:
				this._router.navigate(['/auth/login']);
				break;
			case 403:
				this._router.navigate(['/auth/login']);
				break;
			default:
				break;
		}
	}

}